import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { HourglassEmptyIcon } from "../../icons";
export interface ComingSoonProps {
  title: string;
  description?: string;
}

/**
 * Placeholder reutilizable para funcionalidades aún no implementadas:
 * muestra el título, una descripción breve y un chip "Próximamente".
 */
export const ComingSoon: React.FC<ComingSoonProps> = ({
  title,
  description,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 2,
        minHeight: "60vh",
        px: 3,
      }}
    >
      <Typography variant="h4" component="h1" fontWeight={600}>
        {title}
      </Typography>
      {description && (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ maxWidth: 520 }}
        >
          {description}
        </Typography>
      )}
      <Chip
        icon={<HourglassEmptyIcon />}
        label="Próximamente"
        color="primary"
        variant="outlined"
        sx={{ mt: 1, fontWeight: 600 }}
      />
    </Box>
  );
};
